// extracted by mini-css-extract-plugin
export default {"container":"BaseHeader_container__CAzEm","content":"BaseHeader_content__u0TQd"};